import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { Provider } from 'react-redux';
import { I18nextProvider } from 'react-i18next';
import Swagger from '@mr_dj07/swagger-client';
import { Dimmer, Loader } from 'semantic-ui-react';
import configureStore from './store';
import createI18n from './i18n';
import App from './App';
import PhotoBoothApi from './services/PhotoBoothApi';
import Login from './scenes/login/containers/Login';
import PrivateRoute from './components/PrivateRoute';
import FeathersClient from './services/FeathersClient';
import { setUserFromToken } from './data/actions';

class PhotoBooth extends Component {
  constructor(props) {
    super(props);

    this.store = null;

    this.state = {
      apiLoaded: false
    };
  }

  async appIsReady(client) {
    const apiClient = new PhotoBoothApi(client);
    const feathersClient = new FeathersClient();

    this.store = configureStore(apiClient, feathersClient);
    try {
      const res = await feathersClient.authenticate();

      if (res && res.accessToken) {
        await this.store.dispatch(setUserFromToken(res.accessToken));
      }
    } catch (e) {
      console.log('Not Authenticated');
    }

    this.setState({ apiLoaded: true });
  }

  componentDidMount() {
    // Create API Client from URL
    Swagger(process.env.API_DEF_URL).then(
      // On Success, change base loading state and on setState callback, set client in store.
      client => {
        this.appIsReady(client);
      },
      fail => {
        console.error(fail);
      }
    );
  }

  render() {
    const { apiLoaded } = this.state;
    if (apiLoaded) {
      return (
        <Provider store={this.store}>
          <I18nextProvider i18n={createI18n('en')}>
            <BrowserRouter>
              <Switch>
                <Route path="/login" component={Login} />
                <PrivateRoute component={App} />
              </Switch>
            </BrowserRouter>
          </I18nextProvider>
        </Provider>
      );
    }
    return (
      <Dimmer active>
        <Loader size="huge">Loading</Loader>
      </Dimmer>
    );
  }
}

export default hot(module)(PhotoBooth);



// WEBPACK FOOTER //
// ./src/PhotoBooth.js